import type { VariablesOf } from '@graphql-typed-document-node/core';
import { graphql } from '@/gql';

export const UpdateSubgroupMutation = graphql(`
    mutation UpdateSubgroup($id: ObjectID!, $input: UpdateSubgroupInput!) {
        updateSubgroup(id: $id, input: $input) {
            __typename
            ... on UpdateSubgroupSuccessfulResponse {
                result {
                    ...SubgroupListItemData
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

export type UpdateSubgroupMutationVariables = VariablesOf<typeof UpdateSubgroupMutation>;
